module.exports = {"version":"1.0.0","build":"1","debug":true}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = DEN3
// module chunks = 1